// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__359L0","descriptionRow":"styles_descriptionRow__2X1IF","services__container":"styles_services__container__1PqM2"};